export var EPSILON = 2.220446049250313e-16;

export function swap(A: number[], i0: number, i1: number, t: number) {
	t = A[i0];
	A[i0] = A[i1];
	A[i1] = t;
}

export function hypot(a: number, b: number) {
	a = Math.abs(a);
	b = Math.abs(b);
	if (a > b) {
		b /= a;
		return a * Math.sqrt(1.0 + b * b);
	}
	if (b > 0) {
		a /= b;
		return b * Math.sqrt(1.0 + a * a);
	}
	return 0.0;
}

/**
 * Clamp number within bounds.
 * @returns `low` <= `value` <= `high`
 */
export function clamp(value: number, low: number, high: number): number {
	if (low > high) {
		throw new Error(`Cannot clamp if low (${low}) > high (${high})`);
	}
	if (value < low) {
		return low;
	}

	if (value > high) {
		return high;
	}

	return value;
}

export var Util = {
	swap,
	hypot,
	clamp,
};

export interface Size {
	width: number;
	height: number;
}
